var _Object$create = require("../core-js/object/create");

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/helpers/inheritsLoose.js
 ** module id = 424
 ** module chunks = 0
 **/